import { jsx } from "react/jsx-runtime";
const ArrowIosDown = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.232 9.36a1 1 0 0 1 1.408-.128L12 13.698l5.36-4.466a1 1 0 0 1 1.28 1.536l-6 5a1 1 0 0 1-1.28 0l-6-5a1 1 0 0 1-.128-1.408Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const ArrowIosDown_ArrowIosDown = ArrowIosDown;
export default ArrowIosDown_ArrowIosDown;
